import { AdUnitInfo } from "@common";
import { AppState, campaignCreativesForm, campaignCreativesFormBindings, existingAdUnitListSelector } from "@store";
import { Fieldset } from "@components";
import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import "./ExistingAdUnitSelector.css";
import { Triangle } from "@icons";

interface ExistingAdUnitSelectorComponentProps {
    adUnits: AdUnitInfo[];
    form: typeof campaignCreativesForm.types.selectorResult;
    $events: typeof campaignCreativesForm.types.eventBindings;
}

function ExistingAdUnitSelectorComponent({ form, $events, adUnits }: ExistingAdUnitSelectorComponentProps) {
    return (
        <Fieldset
            className="AdUnitSelector_custom-fieldset"
            label="Existing Adunit"
            errorMessage={form.fields.adUnitId}
            isMandatory={true}
            icon={Triangle}
            svgClassName="svg-triangle"
        >
            <select value={form.fields.adUnitId.value} {...$events.fields.adUnitId}>
                <option value="" key="empty">
                    Select adunit
                </option>
                {adUnits.map(u => (
                    <option value={u.id} key={u.id}>
                        {u.name}
                    </option>
                ))}
            </select>
        </Fieldset>
    );
}

export const ExistingAdUnitSelector = connect(
    (appState: AppState): Partial<ExistingAdUnitSelectorComponentProps> => {
        const form = campaignCreativesForm.selector(appState.campaignState.campaignCreativesForm);
        const adUnits = existingAdUnitListSelector(appState);
        return {
            form,
            adUnits
        };
    },
    (dispatch: Dispatch) => ({
        $events: campaignCreativesFormBindings.bind(dispatch, undefined)
    })
)(ExistingAdUnitSelectorComponent);
